export const DEFAULT_AVATAR_URL =
  'https://cdn.edools.com/assets/images/users/default.jpeg'
